window.URL_BASE = 'https://www.sprinta.com.br/'    
window.URL_DASH_HOME = window.URL_BASE + 'dash/home/dashboard/view/'
window.URL_API = 'https://borapi.sprinta.com.br/'
// window.URL_API = 'https://api.sprinta.com.br/'
window.URL_API_BLOG = 'https://api.sprinta.com.br/blog/'
window.URL_API_TIMELINE = "https://api.k8s.sprinta.com.br/"
window.URL_API_USER = 'https://api.sprinta.com.br/profile_service/'
window.URL_API_EXPERIENCE = 'https://experience.k8s.sprinta.com.br/'
window.URL_API_EVENT = 'https://borapi.sprinta.com.br/event_service/'
window.URL_API_SUBSCRIBE = 'https://subscribe.k8s.sprinta.com.br/'
window.URL_API_CHALLENGE = 'https://api.sprinta.com.br/challenge_service/'
window.URL_RATE = 'https://api.sprinta.com.br/evaluation_service/'
window.URL_SEARCH_ENGINE = 'https://api.sprinta.com.br/search-engine'
// window.URL_CHECKOUT = 'https://checkout.k8s.sprinta.com.br/'
window.URL_CHECKOUT = 'https://boracheckout.sprinta.com.br/'
window.URL_SEARCH_SERVICE = `https://serv.sprinta.com.br/search-service/`

window.strava_client_id = '2044'
window.facebook_client_id = '139285466682385'
window.gmak = "AIzaSyBs35Y5zZ1bip8CEPeu6cLX2pQ2efHGaZo"


window.URL_ASSETS_BASE = window.URL_BASE
window.BASE_URL_OLD = window.URL_BASE
window.URL_BASE_OLD = window.BASE_URL_OLD
window.URL_ASSETS_BASE_API = window.URL_BASE
window.URL_AVATAR = window.URL_BASE


window.config = {
    url_checkout:            window.URL_CHECKOUT,
    url_event_extras_images: window.URL_BASE + 'uploads/extras/',
    url_base_old:            window.URL_BASE,
    url_attachments:         window.URL_BASE + 'uploads/anexos/'
}



// WEBPACK FOOTER //
// ./src/_config.js